import { groupBy, uniq } from 'ramda';
import { COUNTRIES, Country } from '@moda/portal-stanchions';
import { useCountry } from '../CountrySelector';
import { SizeSelectorFragment } from '../../generated/types';

export type Region = {
  name: string;
  scale: string;
  countries: Country[];
};

export const REGIONS: Region[] = [
  {
    name: 'United States',
    scale: 'US',
    countries: COUNTRIES.filter(country => country.alpha2Code === 'US')
  },
  {
    name: 'United Kingdom',
    scale: 'UK',
    countries: COUNTRIES.filter(country => country.alpha2Code === 'GB')
  },
  {
    name: 'Europe',
    scale: 'EU',
    countries: COUNTRIES.filter(
      country =>
        country.region === 'europe' && country.alpha2Code !== 'IT' && country.alpha2Code !== 'FR'
    )
  },
  {
    name: 'Italy',
    scale: 'IT',
    countries: COUNTRIES.filter(country => country.alpha2Code === 'IT')
  },
  {
    name: 'France',
    scale: 'FR',
    countries: COUNTRIES.filter(country => country.alpha2Code === 'FR')
  },
  {
    name: 'Australia',
    scale: 'AU',
    countries: COUNTRIES.filter(country => country.alpha2Code === 'AU')
  },
  {
    name: 'China',
    scale: 'CN',
    countries: COUNTRIES.filter(country => country.alpha2Code === 'CN')
  }
];

export const getSizeRegion = (size?: string | null) =>
  REGIONS.find(region => region.scale === size?.split(' ')[0])?.name || 'Standard';

export const groupSizesByRegion = (sizes: string[]) => groupBy(getSizeRegion, uniq(sizes));

export const hasSizeEquivalents = (sizeEquivalents: string[][]) =>
  sizeEquivalents.length > 0 && Object.keys(groupSizesByRegion(sizeEquivalents[0])).length > 1;

export const showSizeGuide = ({
  sizeEquivalents,
  disableSizeMapping
}: Pick<SizeSelectorFragment, 'sizeEquivalents' | 'disableSizeMapping'>) =>
  !disableSizeMapping && hasSizeEquivalents(sizeEquivalents);

export const usePreferredRegion = () => {
  const { country } = useCountry();
  return REGIONS.find(region => region.countries.includes(country)) || REGIONS[0];
};
